const Routes = {
    IMPRESSUM: "/impressum",
    AGH_HOMEPAGE: "https://www.adeccogroup.de/",
    IMPRESSUM_ADECCO: "https://www.adecco.de/impressum/",
    IMPRESSUM_DIS: "https://www.dis-ag.com/impressum/",
    IMPRESSUM_MODIS: "https://www.akkodis.com/de/datenschutzerklaerung",
    IMPRESSUM_PROSERV: "https://proserv-dl.de/impressum/",
    IMPRESSUM_AGHPLUS: "https://www.adeccogroup.de/impressum/",
    IMPRESSUM_ABS: "https://www.abs-group.de/impressum/"
}
export default Routes;